/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_Visible_Members_HintInputs */

const en_admin_resource_form_visible_members_hint = /** @type {(inputs: Admin_Resource_Form_Visible_Members_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your members can see this resource in the calendar`)
};

const de_admin_resource_form_visible_members_hint = /** @type {(inputs: Admin_Resource_Form_Visible_Members_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Mitglieder können diese Ressource im Kalender sehen`)
};

const es_admin_resource_form_visible_members_hint = /** @type {(inputs: Admin_Resource_Form_Visible_Members_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tus miembros pueden ver este recurso en el calendario`)
};

const fr_admin_resource_form_visible_members_hint = /** @type {(inputs: Admin_Resource_Form_Visible_Members_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vos membres peuvent voir cette ressource dans le calendrier`)
};

const nl_admin_resource_form_visible_members_hint = /** @type {(inputs: Admin_Resource_Form_Visible_Members_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je leden kunnen deze voorziening in de kalender zien`)
};

/** @type {(inputs: Admin_Resource_Form_Visible_Members_HintInputs) => LocalizedString} */
const it_admin_resource_form_visible_members_hint = en_admin_resource_form_visible_members_hint;

/** @type {(inputs: Admin_Resource_Form_Visible_Members_HintInputs) => LocalizedString} */
const pt_br2_admin_resource_form_visible_members_hint = en_admin_resource_form_visible_members_hint;

/** @type {(inputs: Admin_Resource_Form_Visible_Members_HintInputs) => LocalizedString} */
const pl_admin_resource_form_visible_members_hint = en_admin_resource_form_visible_members_hint;

/** @type {(inputs: Admin_Resource_Form_Visible_Members_HintInputs) => LocalizedString} */
const hu_admin_resource_form_visible_members_hint = en_admin_resource_form_visible_members_hint;

/** @type {(inputs: Admin_Resource_Form_Visible_Members_HintInputs) => LocalizedString} */
const ro_admin_resource_form_visible_members_hint = en_admin_resource_form_visible_members_hint;

/**
* | output |
* | --- |
* | "Your members can see this resource in the calendar" |
*
* @param {Admin_Resource_Form_Visible_Members_HintInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_visible_members_hint = /** @type {((inputs?: Admin_Resource_Form_Visible_Members_HintInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_Visible_Members_HintInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_visible_members_hint(inputs)
	if (locale === "de") return de_admin_resource_form_visible_members_hint(inputs)
	if (locale === "es") return es_admin_resource_form_visible_members_hint(inputs)
	if (locale === "fr") return fr_admin_resource_form_visible_members_hint(inputs)
	if (locale === "nl") return nl_admin_resource_form_visible_members_hint(inputs)
	if (locale === "it") return it_admin_resource_form_visible_members_hint(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_visible_members_hint(inputs)
	if (locale === "pl") return pl_admin_resource_form_visible_members_hint(inputs)
	if (locale === "hu") return hu_admin_resource_form_visible_members_hint(inputs)
	return ro_admin_resource_form_visible_members_hint(inputs)
});
export { admin_resource_form_visible_members_hint as "admin.resource_form.visible_members_hint" }